import { EmailValidator, LoginPasswordValidator } from "@/utils/validators";
import * as Yup from "yup";

export const ValidationSchema = Yup.object({
  password: LoginPasswordValidator.required("VALIDATION.REQUIRED"),
  email: EmailValidator.required("VALIDATION.REQUIRED")
});
